/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './block.defs.js'
export { main as default } from './block.defs.js'
